// frontend/src/pages/company/DeliveryOrders.jsx


import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import CompanyLayout from '../../components/layout/CompanyLayout';
import deliveryService from '../../services/deliveryService';
import { shopAPI, districtAPI } from '../../services/api';
import zoneService from '../../services/zoneService';
import CreateDeliveryModal from '../../components/company/CreateDeliveryModal'; 

const DeliveryOrders = () => {
  const { hasPermission } = useAuth();
  const [loading, setLoading] = useState(true);
  const [deliveries, setDeliveries] = useState([]);
  const [shops, setShops] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [khoroos, setKhoroos] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [stats, setStats] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false); 
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [assigning, setAssigning] = useState(false);
  const [expandedItems, setExpandedItems] = useState(false);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [manualFee, setManualFee] = useState('');
  const [feeOption, setFeeOption] = useState('zone');
  const [feeFromCustomer, setFeeFromCustomer] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  });

   const [filters, setFilters] = useState({
    status: '',
    shop_id: '',
    district_id: '',
    khoroo_id: '',
    driver_id: '',
    payment_status: '',
    date_range: 'today',
    date_from: new Date().toISOString().split('T')[0],
    date_to: new Date().toISOString().split('T')[0]
  });

  // Хугацааны тооцоолол
  const getDateRange = (range) => {
    const today = new Date();
    const formatDate = (d) => d.toISOString().split('T')[0];
    
    switch (range) {
      case 'today':
        return { from: formatDate(today), to: formatDate(today) };
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        return { from: formatDate(yesterday), to: formatDate(yesterday) };
      case 'week':
        const weekAgo = new Date(today);
        weekAgo.setDate(weekAgo.getDate() - 7);
        return { from: formatDate(weekAgo), to: formatDate(today) };
      case 'month':
        const monthAgo = new Date(today);
        monthAgo.setDate(monthAgo.getDate() - 30);
        return { from: formatDate(monthAgo), to: formatDate(today) };
      default:
        return { from: formatDate(today), to: formatDate(today) };
    }
  };

  const handleDateRangeChange = (range) => {
    if (range === 'custom') {
      setFilters(prev => ({ ...prev, date_range: range }));
    } else {
      const { from, to } = getDateRange(range);
      setFilters(prev => ({ 
        ...prev, 
        date_range: range,
        date_from: from,
        date_to: to
      }));
    }
  };

  const isFirstRender = useRef(true);

useEffect(() => {
  fetchShops();
  fetchDistricts();
  fetchDrivers();
  fetchZones();
  fetchDeliveries();
}, []);

useEffect(() => {
  // Эхний render дээр skip хийх
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }
  fetchDeliveries();
}, [
  filters.status,
  filters.shop_id,
  filters.district_id,
  filters.khoroo_id,
  filters.driver_id,
  filters.payment_status,
  filters.date_range,
  filters.date_from,
  filters.date_to,
  pagination.page,
  searchQuery
]);

  const fetchShops = async () => {
    try {
      const response = await shopAPI.getAll();
      setShops(response.data.data || []);
    } catch (error) {
      console.error('Shops fetch error:', error);
    }
  };

   const fetchDistricts = async () => {
    try {
      const response = await districtAPI.getAll();
      setDistricts(response.data.data || []);
    } catch (error) {
      console.error('Districts fetch error:', error);
    }
  };

  const fetchKhoroos = async (districtId) => {
    try {
      const response = await districtAPI.getKhoroosByDistrict(districtId);
      setKhoroos(response.data.data || []);
    } catch (error) {
      console.error('Khoroos fetch error:', error);
      setKhoroos([]);
    }
  };

  const fetchDrivers = async () => {
  try {
    const response = await deliveryService.getDrivers();
    if (response.success) {
      setDrivers(response.data || []);
    }
  } catch (error) {
    console.error('Drivers fetch error:', error);
  }
};

// ============================================
// ШИНЭ: Fetch Zones (АЖИЛ 2)
// ============================================
const fetchZones = async () => {
  try {
    const response = await zoneService.getAllZones();
    if (response.success) {
      setZones(response.data || []);
    }
  } catch (error) {
    console.error('Zones fetch error:', error);
  }
};


// ============================================
// Хайлт хийх
// ============================================
const handleSearch = () => {
  setPagination(prev => ({ ...prev, page: 1 }));
  fetchDeliveries();
};


    const fetchDeliveries = async () => {
    // Өмнөх fetch-ийг цуцлах
    setDeliveries([]); // Эхлээд цэвэрлэх
    
    try {
      setLoading(true);
    const params = {
        page: pagination.page,
        limit: pagination.limit,
        include_stats: 'true',
        ...filters
      };

      // Search query нэмэх
      if (searchQuery && searchQuery.trim()) {
        params.search = searchQuery.trim();
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) {
          delete params[key];
        }
      });

       // DEBUG: Uncomment to debug
      // console.log('📦 Filters:', filters);
      // console.log('📦 Params sent to backend:', params);

      const response = await deliveryService.getDeliveries(params);
      
      // console.log('📦 Response:', response);
      if (response.success) {
      // Давхардал арилгах - ID-аар unique болгох
      const uniqueDeliveries = response.data.filter((item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
      );
      setDeliveries(uniqueDeliveries);
        setPagination(prev => ({
          ...prev,
          total: response.pagination.total,
          pages: response.pagination.pages
        }));
        
        if (response.stats) {
          setStats(response.stats);
        }
      }
    } catch (error) {
      console.error('Deliveries fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const selectableIds = deliveries
        .filter(d => d.status !== 'delivered')
        .map(d => d.id);
      setSelectedIds(selectableIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectOne = (id, status) => {
    if (status === 'delivered') return;
    
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i => i !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const handleOpenAssignModal = () => {
    if (selectedIds.length === 0) {
      alert('Хүргэлт сонгоно уу');
      return;
    }
    setShowAssignModal(true);
  };

  // ============================================
// ШИНЭ: Assign Driver + Zone + Fee (АЖИЛ 2)
// ============================================
const handleAssignDriver = async () => {
  if (!selectedDriver) {
    alert('Жолооч сонгоно уу');
    return;
  }

  // Validation
  if (feeOption === 'zone' && !selectedZone) {
    alert('Бүс сонгоно уу');
    return;
  }

  if (feeOption === 'manual' && (!manualFee || parseFloat(manualFee) < 0)) {
    alert('Хүргэлтийн төлбөр оруулна уу');
    return;
  }

  try {
    setAssigning(true);
    
    // ============================================
    // BUILD REQUEST PAYLOAD
    // ============================================
    const payload = {
      delivery_ids: selectedIds,
      driver_id: parseInt(selectedDriver)
    };

    // Option 1: Zone (бүгд ижил zone + fee)
    if (feeOption === 'zone' && selectedZone) {
      payload.zone_id = parseInt(selectedZone);
    }
    // Option 2: Manual fee (бүгд ижил гар оруулалт)
    else if (feeOption === 'manual' && manualFee) {
      payload.zone_id = null;
      payload.delivery_fee = parseFloat(manualFee);
    }
    // Option 3: Default fee (shop бүрийн default_delivery_fee)
    else if (feeOption === 'default') {
      payload.use_default_fee = true;
    }

     // Хүргэлтийн төлбөрийг захиалагчаас авах эсэх
    payload.delivery_fee_from_customer = feeFromCustomer;
    
    // console.log('📦 Bulk assign payload:', payload);

    const response = await deliveryService.bulkAssignDriver(
      payload.delivery_ids,
      payload.driver_id,
      payload.zone_id,
      payload.delivery_fee,
      payload.use_default_fee,
      payload.delivery_fee_from_customer
    );
    
    if (response.success) {
      let message = `✅ ${response.data.updated_count} хүргэлт хувиарлагдлаа`;
      
      if (feeOption === 'zone' && selectedZone) {
        const zone = zones.find(z => z.id === parseInt(selectedZone));
        message += `\n💰 Бүс: ${zone?.zone_name} (${zone?.default_fee?.toLocaleString()}₮)`;
      } else if (feeOption === 'manual') {
        message += `\n💰 Төлбөр: ${parseFloat(manualFee).toLocaleString()}₮`;
      } else if (feeOption === 'default') {
        message += `\n💰 Нэгж төлбөр ашигласан`;
      }
      
      alert(message);
      
      setShowAssignModal(false);
      setSelectedIds([]);
      setSelectedDriver('');
      setSelectedZone('');
      setManualFee('');
      setFeeOption('zone');
      setFeeFromCustomer(false);
      fetchDeliveries();
    }
  } catch (error) {
    console.error('Assign error:', error);
    alert(error.response?.data?.message || error.message || 'Жолооч хувиарлахад алдаа гарлаа');
  } finally {
    setAssigning(false);
  }
};

const handleUnassign = async (deliveryId, deliveryNumber) => {
    if (!confirm(`${deliveryNumber} хүргэлтийн жолоочийн хувиарлалтыг цуцлах уу?\n\nХүргэлт "Хүлээгдэж буй" төлөвт буцна.`)) return;
    try {
      await deliveryService.unassignDriver(deliveryId);
      alert('Жолоочийн хувиарлалт амжилттай цуцлагдлаа');
      fetchDeliveries();
    } catch (error) {
      console.error('Unassign error:', error);
      alert(error.message || 'Хувиарлалт цуцлахад алдаа гарлаа');
    }
  };

  const handleViewDetail = async (deliveryId) => {
    try {
      setDetailLoading(true);
      setShowDetailModal(true);
      setExpandedItems(false); // Reset expand state
      
      const response = await deliveryService.getDeliveryById(deliveryId);
      if (response.success) {
        setSelectedDelivery(response.data);
      }
    } catch (error) {
      console.error('Detail fetch error:', error);
      alert('Дэлгэрэнгүй мэдээлэл татахад алдаа гарлаа');
      setShowDetailModal(false);
    } finally {
      setDetailLoading(false);
    }
  };

  // 4 CARDS
   // Format currency helper (бүтэн дүн)
  const formatCurrency = (amount) => {
    return (amount || 0).toLocaleString() + '₮';
  };

  // Нийт төлбөрийн дүн (бүх төлбөрийн нийлбэр)
  const totalPayment = (stats?.total_amount || 0);

  const getStatusBadge = (status) => {
    const badges = {
      pending: { label: 'Хүлээгдэж буй', color: 'bg-gray-100 text-gray-800 border border-gray-300', icon: '⏸️' },
      in_transit: { label: 'Хүргэж байна', color: 'bg-yellow-100 text-yellow-800 border border-yellow-300', icon: '🚚' },
      delivered: { label: 'Хүргэсэн', color: 'bg-green-100 text-green-800 border border-green-300', icon: '✅' },
      cancelled: { label: 'Цуцалсан', color: 'bg-red-100 text-red-800 border border-red-300', icon: '❌' },
      postponed: { label: 'Хойшилсон', color: 'bg-orange-100 text-orange-800 border border-orange-300', icon: '⏸️' }
    };
    const badge = badges[status] || badges.pending;
    return (
      <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${badge.color}`}>
        <span>{badge.icon}</span>
        <span>{badge.label}</span>
      </span>
    );
  };

  const getPaymentBadge = (paymentStatus) => {
    const badges = {
      unpaid: { label: 'Төлөгдөөгүй', color: 'bg-red-100 text-red-700' },
      paid_by_driver: { label: 'Жолооч', color: 'bg-blue-100 text-blue-700' },
      paid_by_company: { label: 'Компани', color: 'bg-green-100 text-green-700' },
      prepaid: { label: 'Урьдчилсан', color: 'bg-purple-100 text-purple-700' }
    };
    const badge = badges[paymentStatus] || badges.unpaid;
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${badge.color}`}>
        {badge.label}
      </span>
    );
  };

  const selectedDeliveriesList = deliveries.filter(d => selectedIds.includes(d.id));

  return (
    <CompanyLayout>
      <div className="space-y-4 sm:space-y-6">
        {/* Header - RESPONSIVE + CREATE BUTTON */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl sm:rounded-2xl p-4 sm:p-8 text-white shadow-lg">
          <div className="flex items-center justify-between gap-3 sm:gap-4">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/20 backdrop-blur rounded-lg sm:rounded-xl flex items-center justify-center">
                <span className="text-2xl sm:text-4xl">🚚</span>
              </div>
              <div>
                <h1 className="text-xl sm:text-3xl font-bold mb-0.5 sm:mb-1">Хүргэлт удирдах</h1>
                <p className="text-xs sm:text-base text-blue-100">Хүргэлтүүдийн бүртгэл, хяналт, удирдлага</p>
              </div>
            </div>
    
        {/* ============================================ */}
        {/* ШИНЭ: CREATE DELIVERY BUTTON */}
        {/* ============================================ */}
        {hasPermission('delivery.create') && (
          <button
            onClick={() => setShowCreateModal(true)}
            className="hidden sm:flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 bg-white text-blue-600 rounded-xl font-semibold hover:shadow-lg transition"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span>Хүргэлт шивэх</span>
          </button>
        )}
        </div>

        {/* Mobile Create Button */}
        {hasPermission('delivery.create') && (
          <button
            onClick={() => setShowCreateModal(true)}
            className="sm:hidden w-full mt-3 flex items-center justify-center gap-2 px-4 py-2.5 bg-white text-blue-600 rounded-lg font-semibold hover:shadow-lg transition text-sm"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span>Хүргэлт шивэх</span>
          </button>
        )}
        </div>
        {/* Stats Cards - SHOP STYLE */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
          {loading ? (
            [1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="bg-white rounded-2xl p-5 animate-pulse shadow-md">
                <div className="h-4 bg-gray-200 rounded w-1/2 mb-3"></div>
                <div className="h-8 bg-gray-200 rounded w-2/3"></div>
              </div>
            ))
          ) : (
            <>
              {/* Card 1: Нийт хүргэлт */}
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                    <span className="text-2xl">📦</span>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-blue-100">Нийт</p>
                    <p className="text-3xl font-bold">{stats?.total || 0}</p>
                  </div>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-blue-100">🕐 Хүлээгдэж буй:</span>
                  <span className="font-semibold">{stats?.pending || 0}</span>
                </div>
              </div>

              {/* Card 2: Хүргэж байна */}
              <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                    <span className="text-2xl">🚚</span>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-orange-100">Хүргэж байна</p>
                    <p className="text-3xl font-bold">{stats?.in_transit || 0}</p>
                  </div>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-orange-100">Жолоочид хувиарлагдсан</span>
                </div>
              </div>

              {/* Card 3: Хүргэсэн */}
              <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                    <span className="text-2xl">✅</span>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-green-100">Хүргэсэн</p>
                    <p className="text-3xl font-bold">{stats?.delivered || 0}</p>
                  </div>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-green-100">Амжилт:</span>
                  <span className="font-semibold">{stats?.delivered_percentage || 0}%</span>
                </div>
              </div>

              {/* Card 4: Хойшилсон & Цуцалсан */}
              <div className="bg-gradient-to-br from-rose-500 to-pink-600 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                    <span className="text-2xl">⚠️</span>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-rose-100">Асуудалтай</p>
                    <p className="text-3xl font-bold">{(stats?.postponed || 0) + (stats?.cancelled || 0)}</p>
                  </div>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-rose-100">📅 {stats?.postponed || 0} • ❌ {stats?.cancelled || 0}</span>
                </div>
              </div>

              {/* Card 5: Төлбөр */}
              <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 col-span-2 lg:col-span-1">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                    <span className="text-2xl">💰</span>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-purple-100">Нийт дүн</p>
                    <p className="text-xl font-bold">{formatCurrency(totalPayment)}</p>
                  </div>
                </div>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between">
                    <span className="text-purple-100">💵 Жолооч:</span>
                    <span className="font-semibold">{formatCurrency(stats?.driver_account || 0)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-purple-100">🏦 Компани:</span>
                    <span className="font-semibold">{formatCurrency(stats?.company_account || 0)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-purple-100">⏳ Төлөгдөөгүй:</span>
                    <span className="font-semibold text-rose-200">{formatCurrency(stats?.unpaid_amount || 0)}</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

       {/* Filters */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
            {/* Date Range Filter */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Хугацаа</label>
              <select
                value={filters.date_range}
                onChange={(e) => handleDateRangeChange(e.target.value)}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              >
                <option value="today">Өнөөдөр</option>
                <option value="yesterday">Өчигдөр</option>
                <option value="week">7 хоног</option>
                <option value="month">30 хоног</option>
                <option value="custom">Сонгох</option>
              </select>
            </div>

            {/* Shop Filter */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Шоп</label>
              <select
                value={filters.shop_id}
                onChange={(e) => setFilters(prev => ({ ...prev, shop_id: e.target.value }))}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              >
                <option value="">Бүгд ({shops.length})</option>
                {shops.map((shop) => (
                  <option key={shop.id} value={shop.id}>{shop.shop_name}</option>
                ))}
              </select>
            </div>

            {/* Driver Filter */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Жолооч</label>
              <select
                value={filters.driver_id}
                onChange={(e) => setFilters(prev => ({ ...prev, driver_id: e.target.value }))}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              >
                <option value="">Бүгд ({drivers.length})</option>
                {drivers.map((driver) => (
                  <option key={driver.id} value={driver.id}>{driver.driver_name}</option>
                ))}
              </select>
            </div>

               {/* District Filter */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Дүүрэг</label>
              <select
                value={filters.district_id || ''}
                onChange={(e) => {
                  const districtId = e.target.value;
                  setFilters(prev => ({ 
                    ...prev, 
                    district_id: districtId,
                    khoroo_id: '' // Дүүрэг өөрчлөгдөхөд хороо reset
                  }));
                  // Шинэ дүүргийн хороодыг татах
                  if (districtId) {
                    fetchKhoroos(districtId);
                  } else {
                    setKhoroos([]);
                  }
                }}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              >
                <option value="">Бүгд ({districts.length})</option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>{district.name}</option>
                ))}
              </select>
            </div>

            {/* Khoroo Filter - Байнга харагдах, харин disabled */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Хороо</label>
              <select
                value={filters.khoroo_id || ''}
                onChange={(e) => setFilters(prev => ({ ...prev, khoroo_id: e.target.value }))}
                disabled={!filters.district_id || khoroos.length === 0}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
              >
                <option value="">
                  {!filters.district_id 
                    ? 'Дүүрэг сонгоно уу' 
                    : khoroos.length === 0 
                      ? 'Хороо ачаалж байна...'
                      : `Бүгд (${khoroos.length})`
                  }
                </option>
                {khoroos.map((khoroo) => (
                  <option key={khoroo.id} value={khoroo.id}>{khoroo.name}</option>
                ))}
              </select>
            </div>

            {/* Status Filter */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Төлөв</label>
              <select
                value={filters.status}
                onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              >
                <option value="">Бүгд</option>
                <option value="pending">Хүлээгдэж буй</option>
                <option value="assigned">Хувиарлагдсан</option>
                <option value="in_transit">Хүргэж байна</option>
                <option value="delivered">Хүргэсэн</option>
                <option value="postponed">Хойшилсон</option>
                <option value="cancelled">Цуцалсан</option>
              </select>
            </div>

            {/* Payment Status Filter */}
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Төлбөр</label>
              <select
                value={filters.payment_status}
                onChange={(e) => setFilters(prev => ({ ...prev, payment_status: e.target.value }))}
                className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              >
                <option value="">Бүгд</option>
                <option value="unpaid">Төлөгдөөгүй</option>
                <option value="paid_by_driver">Жолооч</option>
                <option value="paid_by_company">Компани</option>
                <option value="prepaid">Урьдчилсан</option>
              </select>
            </div>
          </div>

          {/* Custom Date Range - Хугацаа сонгох үед харуулах */}
          {filters.date_range === 'custom' && (
            <div className="flex gap-3 mt-3 pt-3 border-t border-gray-100">
              <div className="w-40">
                <label className="block text-xs font-medium text-gray-600 mb-1">Эхлэх огноо</label>
                <input
                  type="date"
                  value={filters.date_from}
                  onChange={(e) => setFilters(prev => ({ ...prev, date_from: e.target.value }))}
                  className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="w-40">
                <label className="block text-xs font-medium text-gray-600 mb-1">Дуусах огноо</label>
                <input
                  type="date"
                  value={filters.date_to}
                  onChange={(e) => setFilters(prev => ({ ...prev, date_to: e.target.value }))}
                  className="w-full px-2.5 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          )}
        </div>
        
        {/* Search Bar - Хүргэлт хайх */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1 relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-400 text-lg">🔍</span>
              </div>
              <input
                type="text"
                placeholder="Хүргэлтийн дугаар эсвэл утасны дугаараар хайх..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              />
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleSearch}
                disabled={loading}
                className="px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2 shadow-md hover:shadow-lg transition"
              >
                {loading ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <span>🔍</span>
                )}
                <span>Хайх</span>
              </button>
              {searchQuery && (
                <button
                  onClick={() => {
                    setSearchQuery('');
                    setPagination(prev => ({ ...prev, page: 1 }));
                  }}
                  className="px-4 py-2.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition"
                >
                  ✕ Цэвэрлэх
                </button>
              )}
            </div>
          </div>
          {searchQuery && (
            <p className="text-xs text-gray-500 mt-2">
              💡 "{searchQuery}" хайлтын үр дүн
            </p>
          )}
        </div>

        {/* Bulk Action Bar */}
        {selectedIds.length > 0 && (
          <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-3 sm:p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="text-xl sm:text-2xl">✅</span>
              <span className="text-sm sm:text-base font-semibold text-gray-900">
                {selectedIds.length} хүргэлт сонгогдлоо
              </span>
            </div>
            {hasPermission('delivery.edit') && (
            <button
              onClick={handleOpenAssignModal}
              className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-2.5 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2 text-xs sm:text-sm"
            >
              <span>👤</span>
              <span>Жолооч хувиарлах</span>
            </button>
            )}
          </div>
        )}

        {/* Table - RESPONSIVE */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="p-4 sm:p-5 border-b border-gray-200 bg-gray-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-lg sm:text-xl">📋</span>
                <h3 className="text-sm sm:text-base font-semibold text-gray-900">Хүргэлтүүд</h3>
              </div>
              <div className="text-xs sm:text-sm text-gray-600">
                Нийт: <span className="font-bold text-gray-900">{pagination.total}</span>
              </div>
            </div>
          </div>
          
          {loading ? (
            <div className="p-8 sm:p-12 text-center">
              <div className="inline-block animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-4 border-blue-600 border-t-transparent mb-3 sm:mb-4"></div>
              <p className="text-sm sm:text-base text-gray-600 font-medium">Уншиж байна...</p>
            </div>
          ) : deliveries.length === 0 ? (
            <div className="p-8 sm:p-12 text-center text-gray-500">
              <div className="text-4xl sm:text-6xl mb-3 sm:mb-4">📦</div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">Хүргэлт олдсонгүй</h3>
              <p className="text-xs sm:text-sm text-gray-600">Сонгосон шүүлтүүрт тохирох хүргэлт байхгүй байна</p>
            </div>
          ) : (
            <>
              <div className="overflow-x-auto">
                <table className="w-full min-w-[800px]">
                  <thead className="bg-gray-100 border-b-2 border-gray-200">
                    <tr>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-center">
                        <input
                          type="checkbox"
                          checked={selectedIds.length > 0 && selectedIds.length === deliveries.filter(d => d.status !== 'delivered').length}
                          onChange={handleSelectAll}
                          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                        />
                      </th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-center text-[10px] sm:text-xs font-bold text-gray-700 uppercase">№</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Хүргэлт</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Харилцагч</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-bold text-gray-700 uppercase hidden md:table-cell">Дүүрэг</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-bold text-gray-700 uppercase hidden lg:table-cell">Жолооч</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Төлөв</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-right text-[10px] sm:text-xs font-bold text-gray-700 uppercase hidden xl:table-cell">Хүргэлт</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-right text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Төлбөр</th>
                      <th className="px-3 sm:px-4 py-2 sm:py-3 text-center text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Үйлдэл</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {deliveries.map((delivery, index) => (
                      <tr key={delivery.id} className="hover:bg-blue-50 transition-colors">
                        <td className="px-3 sm:px-4 py-3 sm:py-4 text-center">
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(delivery.id)}
                            onChange={() => handleSelectOne(delivery.id, delivery.status)}
                            disabled={delivery.status === 'delivered'}
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500 disabled:opacity-30 disabled:cursor-not-allowed"
                          />
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4 text-center">
                          <span className="inline-flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 bg-gray-100 text-gray-700 rounded-full font-semibold text-[10px] sm:text-sm">
                            {(pagination.page - 1) * pagination.limit + index + 1}
                          </span>
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4">
                          <button
                            onClick={() => handleViewDetail(delivery.id)}
                            className="flex items-center gap-1.5 sm:gap-2 hover:text-blue-600 transition text-left"
                          >
                            <span className="text-base sm:text-lg">🚚</span>
                            <div>
                              <div className="text-xs sm:text-sm font-bold text-blue-600">
                                {delivery.delivery_number}
                              </div>
                              <div className="text-[10px] sm:text-xs text-gray-500">
                                {delivery.order_number}
                              </div>
                            </div>
                          </button>
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4">
                          <div className="text-xs sm:text-sm font-medium text-gray-900">{delivery.customer_name}</div>
                          <div className="text-[10px] sm:text-xs text-gray-500">📞 {delivery.customer_phone}</div>
                        </td>
                         <td className="px-3 sm:px-4 py-3 sm:py-4 hidden md:table-cell">
                          <div>
                            <span className="text-xs sm:text-sm font-medium text-gray-900">
                              {delivery.district?.name || '-'}
                            </span>
                            {delivery.khoroo && (
                              <div className="text-[10px] sm:text-xs text-gray-500">
                                {delivery.khoroo.name}
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4 hidden lg:table-cell">
                          <div className="text-xs sm:text-sm text-gray-900">
                            {delivery.driver?.driver_name ? (
                              <span className="flex items-center gap-1">
                                <span>👤</span>
                                <span>{delivery.driver.driver_name}</span>
                              </span>
                            ) : (
                              <span className="text-gray-400 italic">Хувиарлаагүй</span>
                            )}
                          </div>
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4">
                          <div className="space-y-1">
                            {getStatusBadge(delivery.status)}
                            {delivery.postpone_count > 0 && (
                              <div className="text-[10px] sm:text-xs text-orange-600">
                                Хойшилсон: {delivery.postpone_count}×
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4 text-right hidden xl:table-cell">
                          {delivery.delivery_fee ? (
                            <div>
                              <span className="font-semibold text-gray-900 text-xs sm:text-sm">
                                {parseFloat(delivery.delivery_fee).toLocaleString()}₮
                              </span>
                              {delivery.delivery_fee_from_customer ? (
                                <span className="block text-[10px] text-orange-600 font-medium">
                                  🚚 Захиалагчаас
                                </span>
                              ) : (
                                <span className="block text-[10px] text-blue-600">
                                  🏪 Шопоос
                                </span>
                              )}
                            </div>
                          ) : (
                            <span className="text-gray-400 text-xs">-</span>
                          )}
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4 text-right">
                          <div className="text-xs sm:text-sm font-bold text-gray-900">
                            {(delivery.cod_amount || 0).toLocaleString()}₮
                          </div>
                          <div className="mt-1">
                            {getPaymentBadge(delivery.payment_status)}
                          </div>
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-4 text-center">
                            <div className="flex items-center justify-center gap-1">
                              <button
                                onClick={() => handleViewDetail(delivery.id)}
                                className="px-2 sm:px-3 py-1 sm:py-1.5 bg-blue-50 text-blue-600 rounded-lg text-[10px] sm:text-xs font-medium hover:bg-blue-100 transition"
                              >
                                Дэлгэрэнгүй
                              </button>
                              {delivery.assigned_driver_id && delivery.status !== 'delivered' && delivery.status !== 'cancelled' && (
                                <button
                                  onClick={() => handleUnassign(delivery.id, delivery.delivery_number)}
                                  className="px-2 sm:px-3 py-1 sm:py-1.5 bg-red-50 text-red-600 rounded-lg text-[10px] sm:text-xs font-medium hover:bg-red-100 transition"
                                >
                                  Цуцлах
                                </button>
                              )}
                            </div>
                          </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination - RESPONSIVE */}
              {pagination.pages > 1 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-gray-50">
                  <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                    <div className="text-xs sm:text-sm text-gray-700">
                      Хуудас <span className="font-semibold">{pagination.page}</span> / <span className="font-semibold">{pagination.pages}</span>
                      {' '}(Нийт: <span className="font-semibold">{pagination.total}</span>)
                    </div>
                    <div className="flex gap-1.5 sm:gap-2">
                      <button
                        onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                        disabled={pagination.page === 1}
                        className="px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-300 rounded-lg text-xs sm:text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition"
                      >
                        ⏮️
                      </button>
                      <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                        disabled={pagination.page === 1}
                        className="px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg text-xs sm:text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition"
                      >
                        ◀️
                      </button>
                      <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                        disabled={pagination.page >= pagination.pages}
                        className="px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg text-xs sm:text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition"
                      >
                        ▶️
                      </button>
                      <button
                        onClick={() => setPagination(prev => ({ ...prev, page: pagination.pages }))}
                        disabled={pagination.page >= pagination.pages}
                        className="px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-300 rounded-lg text-xs sm:text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 transition"
                      >
                        ⏭️
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Assign Driver Modal - RESPONSIVE */}
      {showAssignModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-3 sm:p-4">
          <div className="bg-white rounded-xl sm:rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 sm:p-6 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 sm:gap-3">
                  <span className="text-2xl sm:text-3xl">👤</span>
                  <div>
                    <h3 className="text-lg sm:text-2xl font-bold">Жолооч хувиарлах</h3>
                    <p className="text-xs sm:text-sm text-blue-100 mt-0.5 sm:mt-1">{selectedIds.length} хүргэлт сонгогдсон</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setShowAssignModal(false);
                    setSelectedDriver('');
                    setSelectedZone('');
                    setManualFee('');
                    setFeeOption('zone');
                  }}
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 hover:bg-white/30 rounded-lg transition flex items-center justify-center"
                >
                  <span className="text-xl sm:text-2xl">×</span>
                </button>
              </div>
            </div>

            <div className="p-4 sm:p-6 max-h-[65vh] overflow-y-auto space-y-5 sm:space-y-6">
              {/* Selected Deliveries */}
              <div>
                <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2">
                  <span>📋</span>
                  <span>Сонгогдсон хүргэлтүүд</span>
                </h4>
                <div className="bg-gray-50 rounded-lg p-3 sm:p-4 space-y-2 max-h-48 overflow-y-auto">
                  {selectedDeliveriesList.map((delivery) => (
                    <div key={delivery.id} className="flex items-center justify-between p-2 sm:p-3 bg-white rounded-lg border border-gray-200">
                      <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
                        <span className="text-base sm:text-lg flex-shrink-0">🚚</span>
                        <div className="flex-1 min-w-0">
                          <div className="text-xs sm:text-sm font-semibold text-gray-900 truncate">{delivery.delivery_number}</div>
                          <div className="text-[10px] sm:text-xs text-gray-600 truncate">{delivery.customer_name} • {delivery.district?.name || '-'}</div>
                        </div>
                      </div>
                      <span className="text-[10px] sm:text-xs text-gray-500 hidden md:inline flex-shrink-0 ml-2">
                        {delivery.address.substring(0, 25)}...
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Driver Selection */}
              <div>
                <label className="block text-sm sm:text-base font-semibold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2">
                  <span>👤</span>
                  <span>Жолооч сонгох</span>
                  <span className="text-red-500">*</span>
                </label>
                <select
                  value={selectedDriver}
                  onChange={(e) => setSelectedDriver(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition text-xs sm:text-sm font-medium"
                >
                  <option value="">-- Жолооч сонгох --</option>
                  {drivers.map((driver) => (
                    <option key={driver.id} value={driver.id}>
                      {driver.driver_name} ({driver.phone})
                    </option>
                  ))}
                </select>
              </div>

              {/* ============================================ */}
              {/* ШИНЭ: FEE OPTIONS (ZONE / MANUAL / DEFAULT) */}
              {/* ============================================ */}
              <div>
                <label className="block text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                  <span>💰</span>
                  <span>Хүргэлтийн төлбөр</span>
                </label>

                <div className="space-y-3">
                  {/* Option 1: Zone */}
                  <label className={`flex items-start gap-3 p-4 border-2 rounded-xl cursor-pointer transition ${
                    feeOption === 'zone' ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="feeOption"
                      value="zone"
                      checked={feeOption === 'zone'}
                      onChange={(e) => {
                        setFeeOption(e.target.value);
                        setManualFee('');
                      }}
                      className="w-5 h-5 text-purple-600 mt-0.5"
                    />
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-base sm:text-lg">🗺️</span>
                        <span className="font-semibold text-gray-900">Бүсээр тогтоох</span>
                        <span className="text-xs text-gray-500">(бүгд ижил)</span>
                      </div>
                      {feeOption === 'zone' && (
                        <div className="mt-3">
                          <select
                            value={selectedZone}
                            onChange={(e) => setSelectedZone(e.target.value)}
                            className="w-full px-3 py-2 border-2 border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 text-sm"
                          >
                            <option value="">-- Бүс сонгох --</option>
                            {zones.map((zone) => (
                              <option key={zone.id} value={zone.id}>
                                {zone.zone_name} - {(zone.default_fee || 0).toLocaleString()}₮
                              </option>
                            ))}
                          </select>
                          {selectedZone && (
                            <div className="mt-2 p-3 bg-purple-100 rounded-lg">
                              <p className="text-xs text-purple-900 font-medium">
                                ✅ {zones.find(z => z.id === parseInt(selectedZone))?.zone_name} бүсийн төлбөр:{' '}
                                <span className="font-bold text-base">
                                  {(zones.find(z => z.id === parseInt(selectedZone))?.default_fee || 0).toLocaleString()}₮
                                </span>
                              </p>
                              <p className="text-xs text-purple-700 mt-1">
                                Бүх {selectedIds.length} хүргэлт энэ төлбөртэй болно
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </label>

                  {/* Option 2: Manual Fee */}
                  <label className={`flex items-start gap-3 p-4 border-2 rounded-xl cursor-pointer transition ${
                    feeOption === 'manual' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="feeOption"
                      value="manual"
                      checked={feeOption === 'manual'}
                      onChange={(e) => {
                        setFeeOption(e.target.value);
                        setSelectedZone('');
                      }}
                      className="w-5 h-5 text-blue-600 mt-0.5"
                    />
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-base sm:text-lg">✏️</span>
                        <span className="font-semibold text-gray-900">Гараас оруулах</span>
                        <span className="text-xs text-gray-500">(бүгд ижил)</span>
                      </div>
                      {feeOption === 'manual' && (
                        <div className="mt-3">
                          <input
                            type="number"
                            min="0"
                            placeholder="Төлбөр оруулах (₮)"
                            value={manualFee}
                            onChange={(e) => setManualFee(e.target.value)}
                            className="w-full px-3 py-2 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                          />
                          {manualFee && parseFloat(manualFee) > 0 && (
                            <div className="mt-2 p-3 bg-blue-100 rounded-lg">
                              <p className="text-xs text-blue-900 font-medium">
                                ✅ Төлбөр:{' '}
                                <span className="font-bold text-base">
                                  {parseFloat(manualFee).toLocaleString()}₮
                                </span>
                              </p>
                              <p className="text-xs text-blue-700 mt-1">
                                Бүх {selectedIds.length} хүргэлт энэ төлбөртэй болно
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </label>

                  {/* Option 3: Default Fee */}
                  <label className={`flex items-start gap-3 p-4 border-2 rounded-xl cursor-pointer transition ${
                    feeOption === 'default' ? 'border-green-500 bg-green-50' : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="feeOption"
                      value="default"
                      checked={feeOption === 'default'}
                      onChange={(e) => {
                        setFeeOption(e.target.value);
                        setSelectedZone('');
                        setManualFee('');
                      }}
                      className="w-5 h-5 text-green-600 mt-0.5"
                    />
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-base sm:text-lg">🏪</span>
                        <span className="font-semibold text-gray-900">Нэгж төлбөр</span>
                        <span className="text-xs text-gray-500">(shop бүрийн)</span>
                      </div>
                      <p className="text-xs text-gray-600">
                        Онлайн шоп бүрийн тохируулсан нэгж төлбөрийг ашиглана
                      </p>
                      {feeOption === 'default' && (
                        <div className="mt-3 p-3 bg-green-100 rounded-lg">
                          <p className="text-xs text-green-900 font-medium flex items-center gap-1">
                            <span>✅</span>
                            <span>Хүргэлт бүрийн төлбөр өөр өөр байна (shop-оос хамаарна)</span>
                          </p>
                        </div>
                      )}
                    </div>
                  </label>
                </div>
              </div>

              {/* ============================================ */}
              {/* Захиалагчаас хүргэлтийн төлбөр авах checkbox */}
              {/* ============================================ */}
              <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-4">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={feeFromCustomer}
                    onChange={(e) => setFeeFromCustomer(e.target.checked)}
                    className="w-5 h-5 text-orange-600 rounded mt-0.5"
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-lg">💸</span>
                      <span className="font-semibold text-gray-900">Хүргэлтийн төлбөрийг захиалагчаас авах</span>
                    </div>
                    <p className="text-xs text-gray-600">
                      ✅ Идэвхжүүлбэл: Жолооч захиалагчаас <strong>COD + хүргэлтийн төлбөр</strong> авна
                    </p>
                    <p className="text-xs text-gray-600">
                      ❌ Идэвхгүй бол: Онлайн шопоос хүргэлтийн төлбөр тооцно
                    </p>
                    {feeFromCustomer && (
                      <div className="mt-2 p-2 bg-orange-100 rounded-lg">
                        <p className="text-xs text-orange-800 font-medium">
                          ⚠️ Онлайн шопоос хүргэлтийн төлбөр авахгүй!
                        </p>
                      </div>
                    )}
                  </div>
                </label>
              </div>

              {/* Info Box */}
              <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-3 sm:p-4">
                <div className="flex gap-2 sm:gap-3">
                  <span className="text-lg sm:text-xl flex-shrink-0">💡</span>
                  <div className="text-xs sm:text-sm text-yellow-900">
                    <p className="font-semibold mb-1">Анхаар:</p>
                    <ul className="space-y-1 list-disc list-inside">
                      <li>Жолооч заавал сонгох ёстой</li>
                      <li>Бүс эсвэл төлбөр сонгохгүй бол хүргэлтийн төлбөр тогтоогдохгүй</li>
                      <li>Хувиарласны дараа дахин засах боломжтой</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 sm:p-6 border-t border-gray-200 bg-gray-50 flex gap-2 sm:gap-3">
              <button
                onClick={() => {
                  setShowAssignModal(false);
                  setSelectedDriver('');
                  setSelectedZone('');
                  setManualFee('');
                  setFeeOption('zone');
                }}
                disabled={assigning}
                className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-100 transition disabled:opacity-50 text-xs sm:text-sm"
              >
                Болих
              </button>
              <button
                onClick={handleAssignDriver}
                disabled={assigning || !selectedDriver}
                className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-semibold hover:shadow-lg transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-xs sm:text-sm"
              >
                {assigning ? (
                  <>
                    <div className="w-4 h-4 sm:w-5 sm:h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Хувиарлаж байна...</span>
                  </>
                ) : (
                  <>
                    <span>✅</span>
                    <span>Хувиарлах ({selectedIds.length})</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Detail Modal - RESPONSIVE + EXPANDABLE ITEMS */}
      {showDetailModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-3 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl sm:rounded-2xl max-w-5xl w-full my-4 sm:my-8 shadow-2xl">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 sm:p-6 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg sm:text-2xl font-bold">Хүргэлтийн дэлгэрэнгүй</h3>
                  {selectedDelivery && (
                    <p className="text-xs sm:text-sm text-blue-100 mt-0.5 sm:mt-1">{selectedDelivery.delivery_number}</p>
                  )}
                </div>
                <button
                  onClick={() => {
                    setShowDetailModal(false);
                    setSelectedDelivery(null);
                    setExpandedItems(false);
                  }}
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 hover:bg-white/30 rounded-lg transition flex items-center justify-center"
                >
                  <span className="text-xl sm:text-2xl">×</span>
                </button>
              </div>
            </div>

            {detailLoading ? (
              <div className="p-8 sm:p-12 text-center">
                <div className="inline-block animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-4 border-blue-600 border-t-transparent mb-3 sm:mb-4"></div>
                <p className="text-sm sm:text-base text-gray-600 font-medium">Уншиж байна...</p>
              </div>
            ) : selectedDelivery && (
              <div className="p-4 sm:p-6 max-h-[calc(90vh-120px)] overflow-y-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
                  {/* Үндсэн мэдээлэл */}
                  <div className="space-y-3 sm:space-y-4">
                    <h4 className="text-base sm:text-lg font-bold text-gray-900 flex items-center gap-2">
                      <span>📋</span>
                      <span>Үндсэн мэдээлэл</span>
                    </h4>
                    <div className="space-y-2 sm:space-y-3 bg-gray-50 rounded-lg p-3 sm:p-4">
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Захиалгын дугаар</span>
                        <p className="text-sm sm:text-base font-semibold text-gray-900">{selectedDelivery.order_number}</p>
                      </div>
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Үүсгэсэн огноо</span>
                        <p className="text-sm sm:text-base font-medium text-gray-900">
                          {new Date(selectedDelivery.created_at).toLocaleString('mn-MN')}
                        </p>
                      </div>
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Харилцагч</span>
                        <p className="text-sm sm:text-base font-medium text-gray-900">{selectedDelivery.customer_name}</p>
                        <p className="text-xs sm:text-sm text-gray-600">📞 {selectedDelivery.customer_phone}</p>
                      </div>
                       <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Хаяг</span>
                        <p className="text-sm sm:text-base font-medium text-gray-900">{selectedDelivery.address}</p>
                        {selectedDelivery.address_detail && (
                          <p className="text-xs sm:text-sm text-gray-600">{selectedDelivery.address_detail}</p>
                        )}
                        <div className="text-xs sm:text-sm text-gray-600 mt-1 space-y-0.5">
                          <p>📍 {selectedDelivery.district?.name || '-'}</p>
                          {selectedDelivery.khoroo && (
                            <p className="text-blue-600 font-medium">
                              🏘️ {selectedDelivery.khoroo.name}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Төлөв & Төлбөр */}
                  <div className="space-y-3 sm:space-y-4">
                    <h4 className="text-base sm:text-lg font-bold text-gray-900 flex items-center gap-2">
                      <span>💰</span>
                      <span>Төлөв & Төлбөр</span>
                    </h4>
                    <div className="space-y-2 sm:space-y-3 bg-gray-50 rounded-lg p-3 sm:p-4">
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Төлөв</span>
                        <div className="mt-1.5 sm:mt-2">{getStatusBadge(selectedDelivery.status)}</div>
                      </div>
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Төлбөрийн дүн</span>
                        <p className="text-2xl sm:text-3xl font-bold text-gray-900 my-1.5 sm:my-2">
                          {(selectedDelivery.cod_amount || 0).toLocaleString()}₮
                        </p>
                        <div>{getPaymentBadge(selectedDelivery.payment_status)}</div>
                      </div>
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Жолооч</span>
                        <p className="text-sm sm:text-base font-medium text-gray-900">
                          {selectedDelivery.driver?.driver_name || 'Хувиарлаагүй'}
                        </p>
                        {selectedDelivery.driver?.phone && (
                          <p className="text-xs sm:text-sm text-gray-600">📞 {selectedDelivery.driver.phone}</p>
                        )}
                      </div>
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Онлайн шоп</span>
                        <p className="text-sm sm:text-base font-medium text-gray-900">
                          {selectedDelivery.shop?.shop_name || '-'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* EXPANDABLE ITEMS - ШИНЭ! */}
                {selectedDelivery.outbound?.items && selectedDelivery.outbound.items.length > 0 && (
                  <div className="mb-4 sm:mb-6">
                    {!expandedItems ? (
                      // COLLAPSED VIEW (Summary)
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4">
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center gap-2">
                            <span className="text-base sm:text-lg">📦</span>
                            <span className="text-sm sm:text-base font-bold text-gray-900">
                              {selectedDelivery.outbound.items.length} бараа
                            </span>
                            <span className="text-xs sm:text-sm text-gray-600">
                              • Нийт: {(selectedDelivery.cod_amount || 0).toLocaleString()}₮
                            </span>
                          </div>
                          <button
                            onClick={() => setExpandedItems(true)}
                            className="text-xs sm:text-sm text-blue-600 font-semibold hover:text-blue-700 transition flex items-center gap-1"
                          >
                            <span>Бүгдийг харах</span>
                            <span>▼</span>
                          </button>
                        </div>
                        {/* Quick preview */}
                        <div className="space-y-1">
                          {selectedDelivery.outbound.items.slice(0, 2).map((item, idx) => (
                            <div key={idx} className="text-xs sm:text-sm text-gray-700 flex items-center gap-2">
                              <span>•</span>
                              <span className="font-medium">{item.product?.product_name}</span>
                              <span className="text-gray-500">×{item.quantity}</span>
                            </div>
                          ))}
                          {selectedDelivery.outbound.items.length > 2 && (
                            <div className="text-xs sm:text-sm text-gray-500">
                              ... +{selectedDelivery.outbound.items.length - 2} бараа
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      // EXPANDED VIEW (Full Table)
                      <div>
                        <div className="flex items-center justify-between mb-3 sm:mb-4">
                          <h4 className="text-base sm:text-lg font-bold text-gray-900 flex items-center gap-2">
                            <span>📦</span>
                            <span>Барааны жагсаалт</span>
                          </h4>
                          <button
                            onClick={() => setExpandedItems(false)}
                            className="text-xs sm:text-sm text-blue-600 font-semibold hover:text-blue-700 transition flex items-center gap-1"
                          >
                            <span>Хураах</span>
                            <span>▲</span>
                          </button>
                        </div>
                        <div className="bg-gray-50 rounded-lg overflow-hidden">
                          <div className="overflow-x-auto">
                            <table className="w-full min-w-[500px]">
                              <thead className="bg-gray-200">
                                <tr>
                                  <th className="px-3 sm:px-4 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Бараа</th>
                                  <th className="px-3 sm:px-4 py-2 sm:py-3 text-right text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Тоо ширхэг</th>
                                  <th className="px-3 sm:px-4 py-2 sm:py-3 text-right text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Үнэ</th>
                                  <th className="px-3 sm:px-4 py-2 sm:py-3 text-right text-[10px] sm:text-xs font-bold text-gray-700 uppercase">Дүн</th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200">
                                {selectedDelivery.outbound.items.map((item, index) => (
                                  <tr key={index} className="bg-white">
                                    <td className="px-3 sm:px-4 py-2 sm:py-3">
                                      <div className="text-xs sm:text-sm font-medium text-gray-900">
                                        {item.product?.product_name || '-'}
                                      </div>
                                      {item.variant && (
                                        <div className="text-[10px] sm:text-xs text-gray-500">
                                          {item.variant.variant_name}
                                        </div>
                                      )}
                                    </td>
                                    <td className="px-3 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm text-gray-900">
                                      {item.quantity}
                                    </td>
                                    <td className="px-3 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm text-gray-900">
                                      {(item.unit_price || 0).toLocaleString()}₮
                                    </td>
                                    <td className="px-3 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm font-semibold text-gray-900">
                                      {((item.quantity || 0) * (item.unit_price || 0)).toLocaleString()}₮
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot className="bg-gray-100">
                                <tr>
                                  <td colSpan="3" className="px-3 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm font-bold text-gray-900">
                                    Нийт дүн:
                                  </td>
                                  <td className="px-3 sm:px-4 py-2 sm:py-3 text-right font-bold text-gray-900 text-base sm:text-lg">
                                    {(selectedDelivery.cod_amount || 0).toLocaleString()}₮
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Хойшлуулсан тайлбар */}
                {selectedDelivery.postpone_count > 0 && (
                  <div className="mb-4 sm:mb-6 bg-orange-50 border border-orange-200 rounded-lg p-3 sm:p-4">
                    <h4 className="text-sm sm:text-base font-bold text-orange-900 flex items-center gap-2 mb-2 sm:mb-3">
                      <span>⏸️</span>
                      <span>Хойшлуулсан ({selectedDelivery.postpone_count}×)</span>
                    </h4>
                    {selectedDelivery.postpone_reason_text && (
                      <div className="bg-white rounded p-2 sm:p-3">
                        <span className="text-[10px] sm:text-xs text-gray-500 font-medium">Жолоочийн тайлбар:</span>
                        <p className="text-xs sm:text-sm text-gray-900 mt-1">{selectedDelivery.postpone_reason_text}</p>
                      </div>
                    )}
                  </div>
                )}

               {/* Тэмдэглэл & Заавар & Жолоочийн тайлбар */}
                <div className="space-y-3 sm:space-y-4">
                  {/* Хүргэлтийн заавар */}
                  {selectedDelivery.delivery_instructions && (
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4">
                      <h4 className="text-sm sm:text-base font-bold text-blue-900 mb-2 flex items-center gap-2">
                        <span>📝</span>
                        <span>Хүргэлтийн заавар</span>
                      </h4>
                      <p className="text-xs sm:text-sm text-gray-700">{selectedDelivery.delivery_instructions}</p>
                    </div>
                  )}

                  {/* Нэмэлт тэмдэглэл */}
                  {selectedDelivery.notes && (
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 sm:p-4">
                      <h4 className="text-sm sm:text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                        <span>💬</span>
                        <span>Нэмэлт тэмдэглэл</span>
                      </h4>
                      <p className="text-xs sm:text-sm text-gray-700">{selectedDelivery.notes}</p>
                    </div>
                  )}

                  {/* Цуцалсан тайлбар */}
                  {selectedDelivery.status === 'cancelled' && selectedDelivery.cancel_reason_text && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-3 sm:p-4">
                      <h4 className="text-sm sm:text-base font-bold text-red-900 mb-2 flex items-center gap-2">
                        <span>❌</span>
                        <span>Цуцалсан шалтгаан</span>
                      </h4>
                      <p className="text-xs sm:text-sm text-red-700">{selectedDelivery.cancel_reason_text}</p>
                      {selectedDelivery.cancelled_at && (
                        <p className="text-xs text-red-500 mt-2">
                          📅 {new Date(selectedDelivery.cancelled_at).toLocaleString('mn-MN')}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ============================================ */}
      {/* ШИНЭ: CREATE DELIVERY MODAL */}
      {/* ============================================ */}
      <CreateDeliveryModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={() => {
          setShowCreateModal(false);
          fetchDeliveries();
        }}
      />
    </CompanyLayout>
  );
};

export default DeliveryOrders;